import {
  Box,
  Button,
  Flex,
  FormControl,
  FormLabel,
  Icon,
  Input,
  InputGroup,
  InputRightAddon,
  Select,
  Switch,
  Table,
  TableContainer,
  Tbody,
  Td,
  Text,
  Textarea,
  Th,
  Thead,
  Tr,
} from "@chakra-ui/react";
import { FaEye, FaPlus } from "react-icons/fa";
import { componentState } from "../../../../atoms/componentState";
import TitleFlex from "../defaultComponents/titleFlex";
import { useEffect, useState } from "react";
import { parcelasvendaDigitada } from "../defaultComponents/parcelas";
import { useNavigate } from "react-router-dom";
import { goToVendaDigitadaList } from "../../../../routes/coordinator";
import ModalRevisãoVendaDigitada from "./ModalRevisãoVendaDigitada";
import { NumericFormat, PatternFormat } from "react-number-format";
import jwt_decode from "jwt-decode";
import { JWTToken } from "../../../../routes/privateRoute";
import PermissionsAPI from "../../../../services/permissionsAPI";
import { useSetRecoilState, useRecoilState } from "recoil";
import { customColors } from "../../../../atoms/customColors";

export interface PostVendaDigitada {
  idCliente: number;
  nomePagador: string;
  emailPagador: string;
  cpfPagador: string;
  permitirPix: boolean;
  parcelaMinima: number;
  parcelaMaxima: number;
  mensagem: string;
  itens: Array<ItensVendadigitada>;
  regras?: Array<RulesVendasDigitadas>;
}
export interface ItensVendadigitada {
  descricao: string;
  valorItem: number;
  quantidade: number;
  codigo: string;
}

export interface RulesVendasDigitadas {
  variavel: string;
  regra: string;
  valor: number;
  modo: string;
  taxa: number;
}

export default function AddVendaDigitadaCartao() {
  const navigate = useNavigate();
  const setHeaderLocation = useSetRecoilState(componentState);
  const [perms, setPerms] = useState<Permission[]>([]);

  const token = window.localStorage.getItem("token");

  useEffect(() => {
    setHeaderLocation("Nova Venda Digitada");
  }, []);

  const colors = useRecoilState(customColors)[0];

  let jwtToken: JWTToken = jwt_decode(token || "");
  const idClient = Number(jwtToken.idCliente);

  async function getAllPerms() {
    try {
      const response = await PermissionsAPI.getPermissions(1);
      setPerms(response);
      console.log("Permissões:", response);
    } catch (error) {
      console.log(error);
    }
  }

  const [formData, setFormData] = useState({ cpfPagador: "" });
  interface Permission {
    id: number;
    nome: string;
    descricao: string;
  }
  const initialState = {
    idCliente: idClient,
    nomePagador: "",
    emailPagador: "",
    cpfPagador: "",
    permitirPix: false, //notpermited,
    parcelaMinima: 1,
    parcelaMaxima: 1,
    mensagem: "",
    itens: [],
    regras: [],
  };
  const initialStateItem = {
    descricao: "",
    valorItem: 0,
    quantidade: 1,
    codigo: "",
  };
  const initialstateRules = {
    variavel: "NUM_PARCELAS",
    regra: "==",
    valor: 1,
    modo: "FIXO",
    taxa: 0,
  };

  const [object, setObject] = useState<PostVendaDigitada>(initialState);
  const [itensVenda, setItensVenda] = useState(Array<ItensVendadigitada>);
  const [novoItem, setNovoItem] =
    useState<ItensVendadigitada>(initialStateItem);
  const [objetoModal, setObjetoModal] =
    useState<PostVendaDigitada>(initialState);
  const [OpenModal, setOpenModal] = useState(false);
  const [listaRegras, setListaRegras] = useState(Array<RulesVendasDigitadas>);
  const [novaRegra, setNovaRegra] =
    useState<RulesVendasDigitadas>(initialstateRules);
  const [description, setDescription] = useState(100);
  const [message, setMessage] = useState(200);

  const maxLength = 100;
  const maxLengthTextArea = 200;

  const unMask = (value: any) => {
    return value.replace(/[^0-9]/g, "");
  };

  function onsubmit() {
    const objeto = {
      idCliente: idClient,
      nomePagador: object.nomePagador,
      emailPagador: object.emailPagador,
      cpfPagador: unMask(object.cpfPagador),
      permitirPix: false, //object.permitirPix,
      parcelaMinima: object.parcelaMinima,
      parcelaMaxima: object.parcelaMaxima,
      mensagem: object.mensagem,
      itens: itensVenda,
      regras: listaRegras,
    };
    setObjetoModal(objeto);
    setOpenModal(true);
    // console.log("objeto", objeto);
    /*   console.log("itens", itensVenda); */
  }

  function onChangeParcelaMinima(e: any) {
    setObject({ ...object, parcelaMinima: Number(e.target.value) });
  }
  function onChangeParcelaMaxima(e: any) {
    setObject({ ...object, parcelaMaxima: Number(e.target.value) });
  }

  function onChangeVariableRule(e: any) {
    setNovaRegra({ ...novaRegra, variavel: e.target.value });
  }

  function onChangeRule(e: any) {
    setNovaRegra({ ...novaRegra, regra: e.target.value });
  }

  function onChangeParcelasRules(e: any) {
    setNovaRegra({ ...novaRegra, valor: Number(e.target.value) });
  }
  function onChangeRuleMode(e: any) {
    setNovaRegra({ ...novaRegra, modo: e.target.value });
  }

  function onChangeValorFixo(e: any) {
    // console.log("valor fixo", e);
    setNovaRegra({
      ...novaRegra,
      taxa: Number(e.target.value.slice(3).replace(",", ".")),
    });
  }

  function onChangeValorPercentual(e: any) {
    setNovaRegra({ ...novaRegra, taxa: Number(e.target.value) });
  }

  function submitItensToList() {
    itensVenda.push(novoItem);
    setNovoItem(initialStateItem);
  }

  function submitRulesToList() {
    listaRegras.push(novaRegra);
    setNovaRegra(initialstateRules);
  }

  function removeItem(index: number) {
    const item = Array.from(itensVenda);
    item.splice(index, 1);
    setItensVenda(item);
  }

  function removeRule(index: number) {
    const item = Array.from(listaRegras);
    item.splice(index, 1);
    setListaRegras(item);
  }

  return (
    <Flex
      w={"100%"}
      h={"90vh"}
      bgColor={colors.WHITE}
      px={10}
      pt={4}
      shadow={"lg"}
      overflowY={"scroll"}
      flexDir={"column"}
    >
      <Flex
        w={"100%"}
        h={"fit-content"}
        flexDir={"row"}
        justifyContent={"flex-end"}
        px={5}
      >
        <Button
          bgColor={colors.GRAY}
          color={colors.WHITE}
          onClick={() => {
            goToVendaDigitadaList(navigate);
          }}
        >
          Voltar
        </Button>
      </Flex>
      {/* <TitleFlex item={"Informe o cliente"} />
      <Box w={"25%"}>
        <ClientSelect cliente={cliente} setCliente={setCliente} />
      </Box> */}
      <TitleFlex item={"Informe os dados do pagador"} />
      <Flex w={"100%"} h={"fit-content"} flexDir={"row"} mb={2}>
        <FormControl px={2}>
          <FormLabel>E-mail</FormLabel>
          <Input
            placeholder="E-mail do Pagador"
            onChange={(e: any) => {
              setObject({ ...object, emailPagador: e.target.value });
            }}
          />
        </FormControl>
        <FormControl px={2}>
          <FormLabel>Nome</FormLabel>
          <Input
            placeholder="Nome do Pagador"
            onChange={(e: any) => {
              setObject({ ...object, nomePagador: e.target.value });
            }}
          />
        </FormControl>
        <FormControl mx={2}>
          <FormLabel>CPF ou CNPJ do pagador</FormLabel>
          <Input
            type="text"
            placeholder="Digite o CPF ou CNPJ"
            value={formData.cpfPagador}
            onChange={(e) => {
              let value = e.target.value.replace(/\D/g, ""); // Remove tudo que não é número

              let formatted = "";

              if (value.length <= 11) {
                // Formata como CPF
                formatted = value
                  .replace(/(\d{3})(\d)/, "$1.$2")
                  .replace(/(\d{3})(\d)/, "$1.$2")
                  .replace(/(\d{3})(\d{1,2})/, "$1-$2")
                  .replace(/(-\d{2})\d+?$/, "$1"); // Limita a 11 dígitos
              } else {
                // Formata como CNPJ
                formatted = value
                  .replace(/(\d{2})(\d)/, "$1.$2")
                  .replace(/(\d{3})(\d)/, "$1.$2")
                  .replace(/(\d{3})(\d)/, "$1/$2")
                  .replace(/(\d{4})(\d)/, "$1-$2")
                  .replace(/(-\d{2})\d+?$/, "$1"); // Limita a 14 dígitos
              }

              setFormData({ ...formData, cpfPagador: formatted });
              setObject({ ...object, cpfPagador: value }); // Salva apenas números
            }}
            maxLength={18} // 00.000.000/0000-00
          />
        </FormControl>
      </Flex>
      <TitleFlex item={"Informações sobre pagamento"} />

      {!object.permitirPix ? (
        <>
          <Flex w={"100%"} h={"fit-content"} flexDir={"row"} my={2}>
            <FormControl px={2}>
              <FormLabel>Parcelamento mínimo</FormLabel>
              <Select
                placeholder=""
                value={object.parcelaMinima.toString()}
                onChange={onChangeParcelaMinima}
              >
                {parcelasvendaDigitada.map((item) => {
                  return (
                    <option value={item.value} key={item.key}>
                      {item.text}
                    </option>
                  );
                })}
              </Select>
            </FormControl>
            <FormControl px={2}>
              <FormLabel>Parcelamento máximo</FormLabel>
              <Select
                placeholder=""
                value={object.parcelaMaxima.toString()}
                onChange={onChangeParcelaMaxima}
              >
                {parcelasvendaDigitada.map((item) => {
                  return (
                    <option value={item.value} key={item.key}>
                      {item.text}
                    </option>
                  );
                })}
              </Select>
            </FormControl>
          </Flex>

          {listaRegras.length ? (
            <>
              <TitleFlex item={"Reagras cadastrados para esta venda"} />
              <Flex
                w={"100%"}
                h={"fit-content"}
                flexDir={"row"}
                mt={4}
                alignItems={"end"}
                justifyContent={"flex-start"}
              >
                <TableContainer>
                  <Table>
                    <Thead>
                      <Tr>
                        <Th
                          borderRadius={"8px 0 0 8px"}
                          bgColor={colors.BLUEMONEDDBUTTONS}
                          color={colors.WHITE}
                        >
                          Variável
                        </Th>
                        <Th
                          bgColor={colors.BLUEMONEDDBUTTONS}
                          color={colors.WHITE}
                        >
                          Regra
                        </Th>
                        <Th
                          bgColor={colors.BLUEMONEDDBUTTONS}
                          color={colors.WHITE}
                        >
                          Parcela
                        </Th>
                        <Th
                          bgColor={colors.BLUEMONEDDBUTTONS}
                          color={colors.WHITE}
                        >
                          Modo
                        </Th>
                        <Th
                          bgColor={colors.BLUEMONEDDBUTTONS}
                          color={colors.WHITE}
                        >
                          Taxa
                        </Th>
                        <Th
                          borderRadius={"0 8px 8px 0"}
                          bgColor={colors.BLUEMONEDDBUTTONS}
                          color={colors.WHITE}
                        >
                          Opções
                        </Th>
                      </Tr>
                    </Thead>
                    <Tbody>
                      {listaRegras &&
                        listaRegras.map((item, index) => {
                          return (
                            <Tr key={index}>
                              <Td>
                                {item.variavel === "NUM_PARCELAS" &&
                                  "Número de Parcelas"}
                              </Td>
                              <Td>{item.regra}</Td>
                              <Td>{item.valor}</Td>
                              <Td>
                                {(item.modo === "FIXO" && "Fixo") ||
                                  (item.modo === "PERCENTUAL" &&
                                    "Percentual") ||
                                  (item.modo === "PERCENTUAL_COMPOSTO" &&
                                    "Percentual Composto")}
                              </Td>
                              <Td>
                                {item.modo === "FIXO"
                                  ? item.taxa.toLocaleString("pt-BR", {
                                      style: "currency",
                                      currency: "BRL",
                                    })
                                  : `${item.taxa} %`}
                              </Td>
                              <Td>
                                <Button
                                  bgColor={colors.REDMONEDD}
                                  color={colors.WHITE}
                                  onClick={() => {
                                    removeRule(index);
                                  }}
                                >
                                  <Text fontWeight={"bold"}>X</Text>
                                </Button>
                              </Td>
                            </Tr>
                          );
                        })}
                    </Tbody>
                  </Table>
                </TableContainer>
              </Flex>
            </>
          ) : (
            <></>
          )}
        </>
      ) : (
        <></>
      )}
      <TitleFlex item={"Informe o produto ou serviço"} />
      <Flex
        w={"100%"}
        h={"fit-content"}
        flexDir={"row"}
        my={2}
        alignItems={"end"}
        justifyContent={"space-evenly"}
      >
        <FormControl px={2} maxWidth={"20%"}>
          <FormLabel>Descrição</FormLabel>
          <InputGroup>
            <Input
              placeholder="Descrição do Produto"
              value={novoItem.descricao}
              onChange={(e: any) => {
                setNovoItem({ ...novoItem, descricao: e.target.value });
                setDescription(maxLength - e.target.value.length);
              }}
              maxLength={maxLength}
            />
            <InputRightAddon w={"30%"} p={0}>
              <Box
                px="2"
                py="1"
                // bg="gray.200"
                borderRadius="md"
                fontSize="sm"
                fontWeight="medium"
                color="gray.500"
              >
                {description}/{maxLength}
              </Box>
            </InputRightAddon>
          </InputGroup>
        </FormControl>
        <FormControl px={2} maxWidth={"20%"}>
          <FormLabel>Valor Unitário</FormLabel>
          <NumericFormat
            decimalScale={2}
            prefix="R$ "
            value={novoItem.valorItem}
            decimalSeparator=","
            customInput={Input}
            type="text"
            placeholder="R$ 0,00"
            onChange={(e: any) => {
              setNovoItem({
                ...novoItem,
                valorItem: Number(e.target.value.slice(3).replace(",", ".")),
              });
            }}
          />
        </FormControl>
        <FormControl px={2} maxWidth={"20%"}>
          <FormLabel>{`Quantidade (Opcional)`}</FormLabel>
          <Input
            placeholder="Quantidade"
            value={novoItem.quantidade}
            onChange={(e: any) => {
              setNovoItem({ ...novoItem, quantidade: Number(e.target.value) });
            }}
          />
        </FormControl>
        <FormControl px={2} maxWidth={"20%"}>
          <FormLabel>{`Código (Opcional)`}</FormLabel>
          <Input
            placeholder="Código"
            value={novoItem.codigo}
            onChange={(e: any) => {
              setNovoItem({ ...novoItem, codigo: e.target.value });
            }}
          />
        </FormControl>
        <Button
          bgColor={colors.BLUEMONEDDBUTTONS}
          isDisabled={
            novoItem.descricao != "" && novoItem.valorItem > 0 ? false : true
          }
          color={colors.WHITE}
          width={"20%"}
          onClick={() => {
            submitItensToList();
          }}
        >
          <Icon mr={2} as={FaPlus} />
          Adicionar
        </Button>
      </Flex>
      {itensVenda.length ? (
        <>
          <TitleFlex item={"Itens cadastrados para esta venda"} />
          <Flex
            w={"100%"}
            h={"fit-content"}
            flexDir={"row"}
            mt={4}
            alignItems={"end"}
            justifyContent={"flex-start"}
          >
            <TableContainer>
              <Table>
                <Thead>
                  <Tr>
                    <Th
                      borderRadius={"8px 0 0 8px"}
                      bgColor={colors.BLUEMONEDDBUTTONS}
                      color={colors.WHITE}
                    >
                      Descrição
                    </Th>
                    <Th bgColor={colors.BLUEMONEDDBUTTONS} color={colors.WHITE}>
                      Valor
                    </Th>
                    <Th bgColor={colors.BLUEMONEDDBUTTONS} color={colors.WHITE}>
                      Quantidade
                    </Th>
                    <Th bgColor={colors.BLUEMONEDDBUTTONS} color={colors.WHITE}>
                      Código
                    </Th>
                    <Th
                      borderRadius={"0 8px 8px 0"}
                      bgColor={colors.BLUEMONEDDBUTTONS}
                      color={colors.WHITE}
                    >
                      Opções
                    </Th>
                  </Tr>
                </Thead>
                <Tbody>
                  {itensVenda &&
                    itensVenda.map((item, index) => {
                      return (
                        <Tr key={index}>
                          <Td>{item.descricao}</Td>
                          <Td>
                            {item.valorItem.toLocaleString("pt-BR", {
                              style: "currency",
                              currency: "BRL",
                            })}
                          </Td>
                          <Td>{item.quantidade}</Td>
                          <Td>{item.codigo}</Td>
                          <Td>
                            <Button
                              bgColor={colors.REDMONEDD}
                              color={colors.WHITE}
                              onClick={() => {
                                removeItem(index);
                              }}
                            >
                              <Text fontWeight={"bold"}>X</Text>
                            </Button>
                          </Td>
                        </Tr>
                      );
                    })}
                </Tbody>
              </Table>
            </TableContainer>
          </Flex>
        </>
      ) : (
        <></>
      )}
      <TitleFlex item={"Mensagem para o pagador (opcional)"} />
      <Flex
        w={"100%"}
        h={"fit-content"}
        flexDir={"row"}
        my={2}
        alignItems={"end"}
        justifyContent={"space-evenly"}
      >
        <FormControl>
          <InputGroup>
            <Textarea
              placeholder="Mensagem..."
              onChange={(e: any) => {
                setObject({ ...object, mensagem: e.target.value });
                setMessage(maxLengthTextArea - e.target.value.length);
              }}
              maxLength={maxLengthTextArea}
            />
            <Flex
              textAlign="right"
              pt={1}
              alignItems={"center"}
              px="2"
              py="1"
              bg="gray.200"
              borderRadius="md"
              fontSize="sm"
              fontWeight="medium"
              color="gray.500"
            >
              <Text fontSize="sm" color="gray.500">
                {message}/{maxLengthTextArea}
              </Text>
            </Flex>
          </InputGroup>
        </FormControl>
      </Flex>
      <Flex
        w={"100%"}
        h={"fit-content"}
        flexDir={"row"}
        my={2}
        alignItems={"end"}
        justifyContent={"space-evenly"}
      >
        <Button
          bgColor={colors.BLUEMONEDDBUTTONS}
          color={colors.WHITE}
          width={"50%"}
          onClick={() => {
            onsubmit();
          }}
        >
          <Icon mr={2} as={FaEye} />
          Revisar Venda Digitada
        </Button>
      </Flex>
      <ModalRevisãoVendaDigitada
        isOpen={OpenModal}
        setIsOpen={setOpenModal}
        item={objetoModal}
      />
    </Flex>
  );
}
